export const CSS_COLORS = {
    FIELD_WARNING: '#A00000',
};
